import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const imageLicenses = {
  col1: [
    "\u00a9 vege - Fotolia.com (ID: 61003743)",
    "\u00a9 vege - Fotolia.com (ID: 68888128)",
    "\u00a9 kraftwerk - Fotolia.com (ID: 43816459)",
    "\u00a9 stnazkul - Fotolia.com (ID: 70043857)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71558445)",
    "\u00a9 ty - Fotolia.com (ID: 69876126)",
    "\u00a9 stnazkul - Fotolia.com (ID: 74318288)",
  ],
  col2: [
    "\u00a9 everythingpossible - Fotolia.com (ID: 75176784)",
    "\u00a9 PRCreativeTeam - Fotolia.com (ID: 32926218)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 60594952)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555591)",
    "\u00a9 kalafoto - Fotolia.com (ID: 76548158)",
    "\u00a9 Sergey Nivens - Fotolia.com (ID: 75074205)",
    "\u00a9 Minerva Studio - Fotolia.com (ID: 44001165)",
  ],
  col3: [
    "\u00a9 ty - Fotolia.com (ID: 77611976)",
    "\u00a9 Brian Jackson - Fotolia.com (ID: 71272430)",
    "\u00a9 vege - Fotolia.com (ID: 68009271)",
    "\u00a9 vege - Fotolia.com (ID: 69466546)",
    "\u00a9 lenetsnikolai - Fotolia.com (ID: 79605839)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 67233512)",
    "\u00a9 vege - Fotolia.com (ID: 68666829)",
  ],
  col4: [
    "\u00a9 vege - Fotolia.com (ID: 64727666)",
    "\u00a9 vege - Fotolia.com (ID: 68576622)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 53066900)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 68132249)",
    "\u00a9 vege - Fotolia.com (ID: 70085709)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555523)",
    "\u00a9 bloomua - Fotolia.com (ID: 44334833)",
    "\u00a9 vege - Fotolia.com (ID: 69992403)",
  ],
};

export default function ImprintEsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageHead
        title="Aviso Legal | NetBasis International"
        description="Aviso legal, exención de responsabilidad y créditos de imágenes de NetBasis International de acuerdo con los requisitos legales."
        ogUrl="https://net-basis.net/es/aviso-legal"
      />
      <Header />
      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero Image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/netbasis-legal-notice-privacy-policy.webp"
                alt="Aviso legal"
                title="Aviso legal"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 md:gap-12 lg:gap-16">
              {/* Left Column - 1/3 */}
              <div className="w-full md:w-1/3">
                <section>
                  <h1 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Aviso legal
                  </h1>

                  <div className="space-y-6">
                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Información según § 5 DDG
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Christof Günther{'\n'}NetBasis International{'\n'}Heinrichstraße 45{'\n'}40239 Düsseldorf{'\n'}Alemania
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Contacto
                      </h2>
                      <div className="font-body text-sm md:text-base text-foreground-950 leading-relaxed space-y-1">
                        <p>
                          <span className="text-foreground-950">Teléfono:</span>{" "}
                          <a
                            href="tel:+4921154419380"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            +49 (0) 211 / 544 193 80
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Correo electrónico:</span>{" "}
                          <a
                            href="mailto:contact@net-basis.com"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            contact@net-basis.com
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Internet:</span>{" "}
                          <a
                            href="https://net-basis.net/es"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            net-basis.net
                          </a>
                        </p>
                      </div>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Número de identificación fiscal
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Número de identificación a efectos del IVA según § 27 a UStG:{'\n'}DE 258 486 954
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Seguro de responsabilidad civil profesional
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Nombre y domicilio social de la aseguradora:{'\n'}Hiscox AG en representación de Hiscox Insurance Company Ltd.{'\n'}Sucursal para Alemania, Arnulfstraße 31, 80636 Múnich{'\n'}Ámbito de cobertura: Mundial
                      </p>
                    </div>
                  </div>
                </section>
              </div>

              {/* Right Column - 2/3 */}
              <div className="w-full md:w-2/3">
                <section>
                  <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Descargo de responsabilidad
                  </h2>

                  <div className="space-y-6">
                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Responsabilidad por el contenido
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        El contenido de nuestro sitio web ha sido creado con el máximo cuidado. Sin embargo, no podemos garantizar la exactitud, integridad y actualidad del contenido. Como proveedor de servicios, somos responsables de nuestro propio contenido en estas páginas de acuerdo con las leyes generales. Sin embargo, no estamos obligados a supervisar la información de terceros transmitida o almacenada ni a investigar circunstancias que indiquen una actividad ilegal. Las obligaciones de eliminar o bloquear el uso de la información según las leyes generales no se ven afectadas. Sin embargo, la responsabilidad a este respecto solo es posible a partir del momento en que tengamos conocimiento de una infracción concreta. En cuanto tengamos conocimiento de las correspondientes infracciones legales, eliminaremos este contenido de inmediato.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Responsabilidad por los enlaces
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Nuestra oferta contiene enlaces a sitios web externos de terceros, sobre cuyo contenido no tenemos ninguna influencia. Por lo tanto, no podemos asumir ninguna responsabilidad por estos contenidos externos. El respectivo proveedor u operador de las páginas enlazadas es siempre responsable del contenido de las mismas. Las páginas enlazadas fueron revisadas en el momento de la vinculación para detectar posibles violaciones legales. En el momento de la vinculación no se reconocían contenidos ilegales. Sin embargo, un control permanente del contenido de las páginas enlazadas no es razonable sin indicios concretos de una violación legal. En cuanto tengamos conocimiento de infracciones legales, eliminaremos dichos enlaces de inmediato.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Derechos de autor
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        El contenido y las obras creadas o utilizadas por nosotros en estas páginas están sujetos a la ley alemana de derechos de autor. La reproducción, el procesamiento, la distribución y cualquier tipo de explotación fuera de los límites de los derechos de autor requieren nuestro consentimiento. Las descargas y copias de este sitio solo están permitidas para uso privado y no comercial. En la medida en que el contenido de nuestro sitio no haya sido creado por nosotros, se respetan los derechos de autor de terceros. En particular, el contenido de terceros se identifica como tal. No obstante, si tuviera conocimiento de una infracción de los derechos de autor, le rogamos que nos lo comunique. En cuanto tengamos conocimiento de infracciones legales, eliminaremos dicho contenido de inmediato.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Créditos de imágenes
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Las imágenes de Fotolia/Adobe Stock utilizadas en este sitio web han sido debidamente licenciadas. Consulte el siguiente resumen para obtener información detallada sobre los derechos de autor:
                      </p>
                      <div className="mt-4 w-full">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1">
                          {imageLicenses.col1.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col2.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col3.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col4.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}